var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { Stack, Avatar, Typography, Button } from "@mui/material";
import { Colors } from "../../util/theme";
export var CardServico = function (_a) {
    var icone = _a.icone, titulo = _a.titulo, descricao = _a.descricao, irPara = _a.irPara, isVeiculo = _a.isVeiculo;
    var navigate = useNavigate();
    return (_jsxs(Stack, __assign({ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center", borderRadius: 2, boxShadow: 2, padding: "0.5rem", width: !isVeiculo ? { md: "30%", sm: "40%", xs: "100%" } : "80%", height: { md: "12rem", xs: "15rem" }, sx: { backgroundColor: "white" } }, { children: [_jsx(Avatar, __assign({ sx: {
                    backgroundColor: Colors.AZUL_GOV,
                    padding: "0.5rem",
                } }, { children: icone })), _jsx(Typography, __assign({ mt: 1, fontSize: "1rem", fontWeight: 500 }, { children: titulo })), _jsx(Typography, __assign({ variant: "caption", color: "textSecondary" }, { children: descricao })), _jsx(Button, __assign({ variant: "text", onClick: function () { return navigate(irPara); }, sx: { color: Colors.AZUL_GOV } }, { children: "ACESSAR" }))] })));
};
